import Align from './Align';
export default Align;
